import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './LoginPage.css';
import logo from './../assets/logo.svg';
import defaultPlaceholder from './../assets/placeholder.png';
import ApiService from './../services/ApiService';
import ErrorCodes from '../services/ErrorCodes';
import CaptchaModal from '../components/CaptchaModal';


const RegisterPage = () => {
    const [placeholderImage, setPlaceholderImage] = useState(defaultPlaceholder);
    const [login, setLogin] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [hasProblem, setHasProblem] = useState(false);
    const [problemText, setProblemText] = useState('');
    const [isAgreed, setIsAgreed] = useState(false);
    const [captchaImage, setCaptchaImage] = useState('');
    const [captchaToken, setCaptchaToken] = useState('');
    const [captchaInput, setCaptchaInput] = useState('');
    const [captchaVerified, setCaptchaVerified] = useState(false);
    const [captchaLoading, setCaptchaLoading] = useState(false);
    const [captchaModalOpen, setCaptchaModalOpen] = useState(false);
    const [captchaError, setCaptchaError] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        document.title = 'Регистрация в animix';
        const getRandomNumber = (min, max) => Math.floor(Math.random() * (max - min + 1)) + min;
        const randomImageNumber = getRandomNumber(1, 3);

        try {
            const randomImage = require(`./../assets/back_${randomImageNumber}.png`);
            setPlaceholderImage(randomImage);
        } catch (error) {
            console.error('Error loading random placeholder image:', error);
        }

        loadNewCaptcha();
    }, []);

    const loadNewCaptcha = async () => {
        try {
            setCaptchaLoading(true);
            const response = await fetch('https://captcha.ety.one/api/captcha');
            
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            
            const data = await response.json();
            setCaptchaImage(data.imageBase64);
            setCaptchaToken(data.token);
            setCaptchaInput('');
            setCaptchaVerified(false);
            setCaptchaError("")
        } catch (error) {
            console.error('Error loading captcha:', error);
        
            setCaptchaError('Возможно, Вы превысили количество допустимых попыток. Попробуйте позже');
        } finally {
            setCaptchaLoading(false);
        }
    };

    const verifyCaptcha = async () => {
        if (!captchaInput.trim()) {
            setCaptchaError('Введите код с картинки');
            return false;
        }

        try {
            const response = await fetch('https://captcha.ety.one/api/captcha/verify', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    token: captchaToken,
                    code: captchaInput
                })
            });

            if (response.status === 200) {
                return true;
            } else {
                loadNewCaptcha();
                return false;
            }
        } catch (error) {
            console.error('Error verifying captcha:', error);
            loadNewCaptcha();
            return false;
        }
    };

    const handleModalCaptchaSubmit = async () => {
        const isVerified = await verifyCaptcha();
        if (isVerified) {
            console.debug("close")
            setCaptchaModalOpen(false);
            setCaptchaError('');
            // Proceed directly with registration without relying on state
            await performRegistration();
        } else {
            setCaptchaError('Неверный код');
        }
    };

    const performRegistration = async () => {
        try {
            setHasProblem(false);
            const response = await ApiService.registerUser(login, password, 121212, captchaToken);

            if (response["type"] === "success") {
                localStorage.setItem('sessionKey', response.data.key);
                navigate('/');
            } else {
                setHasProblem(true);
                setProblemText(ErrorCodes.getText(response));
                loadNewCaptcha();
            }
        } catch (error) {
            console.error('Error registering user:', error.message);
            setHasProblem(true);
            setProblemText("Неизвестная ошибка. " + error.message);
            loadNewCaptcha();
        }
    };

    const handleCreateAccount = async (event) => {
        event.preventDefault();

        if (!isAgreed) {
            setHasProblem(true);
            setProblemText('Вы должны согласиться с условиями политики конфиденциальности и публичной оферты');
            return;
        }

        if (password !== confirmPassword) {
            setHasProblem(true);
            setProblemText('Пароли не совпадают');
            return;
        }

        if (password.length < 8) {
            setHasProblem(true);
            setProblemText('Пароль слишком короткий');
            return;
        }

        if (!captchaVerified) {
            setCaptchaModalOpen(true);
            return;
        }

        await performRegistration();
    };

    const handleLogin = () => navigate('/login');

    return (
        <div className="login-page">
            <div className="left-section">
                <div className="placeholder-container">
                    <img src={placeholderImage} alt="Placeholder" className="placeholder-image" />
                </div>
            </div>

            <div className="right-section">
                <a href="/"><img className="login-logo" src={logo} alt="Logo" /></a>
                <form className="login-form" onSubmit={handleCreateAccount}>
                    {hasProblem && <p className="banner">{problemText}</p>}
                    <input type="text" placeholder="Логин" value={login} onChange={(e) => setLogin(e.target.value)} />
                    <input type="password" placeholder="Пароль" value={password} onChange={(e) => setPassword(e.target.value)} />
                    <input type="password" placeholder="Повтор" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} />

                    <div className="checkbox-container">
                        <input
                            type="checkbox"
                            id="terms-checkbox"
                            checked={isAgreed}
                            onChange={(e) => setIsAgreed(e.target.checked)}
                        />
                        <label htmlFor="terms-checkbox">
                            Согласен(-на) с политикой конфиденциальности, офертой
                        </label>
                    </div>

                    <button type="submit" className='button-login'>Создать аккаунт</button>
                    <button className='button-sec login' onClick={handleLogin}>Войти</button>
                    <p className="privacy">Используя сайт, вы соглашаетесь с нашей политикой конфиденциальности</p>
                </form>
            </div>

            {captchaModalOpen && <CaptchaModal
                isOpen={captchaModalOpen}
                captchaImage={captchaImage}
                captchaInput={captchaInput}
                onInputChange={(e) => setCaptchaInput(e.target.value)}
                onRefresh={loadNewCaptcha}
                onSubmit={handleModalCaptchaSubmit}
                onClose={() => setCaptchaModalOpen(false)}
                loading={captchaLoading}
                error={captchaError}
            />}

        </div>
    );
};

export default RegisterPage;